const adjustNav = (): JQuery<HTMLElement> => {
  try {
    // Check if is not on mobile
    if ($('.header nav').css('display') === 'none') return;

    let navItemsWidth = 2; // Initialize value with a small buffer, since webkit antialises font sizes
    const moreItemWidth = $('#desktop-nav-more').outerWidth(true);

    // sum up width of all navigation items except the more item
    $('#desktop-nav > li:not(#desktop-nav-more)').each(function() {
      navItemsWidth += $(this).outerWidth(true);
    });

    const availableSpace = $('#desktop-nav').width() - moreItemWidth;

    if (navItemsWidth > availableSpace) {
      const lastItem = $('#desktop-nav > li:not(#desktop-nav-more)').last();
      lastItem.attr('data-width', lastItem.outerWidth(true));
      lastItem.prependTo($('#desktop-nav-overflow'));
      adjustNav();
    } else {
      const firstMoreElement = $('#desktop-nav-overflow li').first();
      if (navItemsWidth + firstMoreElement.data('width') < availableSpace) {
        firstMoreElement.insertBefore($('#desktop-nav-more'));
      }
    }

    if ($('#desktop-nav-overflow li').length > 0) {
      return $('#desktop-nav-more').addClass('d-block');
    }

    return $('#desktop-nav-more').removeClass('d-block');
    // eslint-disable-next-line no-empty
  } catch {}
};

((_$, sr): void => {
  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  const debounce = function(func: Function, threshold?: number, execAsap?: boolean): unknown {
    let timeout: NodeJS.Timeout;

    return function debounced(...args: unknown[]): void {
      function delayed(): void {
        if (!execAsap) func.apply(this, args);
        timeout = null;
      }

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const obj = this;

      if (timeout) clearTimeout(timeout);
      else if (execAsap) func.apply(obj, args);

      timeout = setTimeout(delayed, threshold || 100);
    };
  };

  // smartresize
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (jQuery as any).fn[sr as string] = function(fn: Function): void {
    return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
  };
})(jQuery, 'smartresize');

function initHeaderLogic(): void {
  $(window).on('load resize', function() {
    adjustNav();
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ($(window) as any).smartresize((): void => {
    adjustNav();
  });

  // Fix for iOS devices to avoid touch on the link to be called immediately
  document.addEventListener('touchstart', $.noop, true);
}

export function initHeader(): void {
  initHeaderLogic();
  adjustNav();
}
